import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, Divider } from "@material-ui/core";
import smartParkService from "../../axios";

const McpStatus = () => {
  const [fieldsData, setfieldsData] = useState(null);
  const [courtsData, setcourtsData] = useState(null);

  const fetchCourtsData = async (url) => {
    let data = {};
    const res = await smartParkService
      .get(url, {
        headers: {
          "x-access-token": "citizen",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.data?.length > 0) {
            return res.data.data;
          }
        }
      });

    if (res?.length > 0) {
      res.forEach((court) => {
        if (!data[court.FieldGroup]) {
          data[court.FieldGroup] = [];
        }
        data[court.FieldGroup].push(court);
      });
    }
    setcourtsData(data);
  };

  const fetchFieldsData = async (url) => {
    let data = {};
    const res = await smartParkService
      .get(url, {
        headers: {
          "x-access-token": "citizen",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.data?.length > 0) {
            return res.data.data;
          }
        }
      });
    if (res?.length > 0) {
      res.forEach((court) => {
        if (!data[court.FieldGroup]) {
          data[court.FieldGroup] = [];
        }
        data[court.FieldGroup].push(court);
      });
    }
    setfieldsData(data);
  };

  useEffect(() => {
    fetchCourtsData("api/mcpcourts");
    fetchFieldsData("api/citizen/fielddata2");
  }, []);

  const renderFields = (key, value, fieldSize = 6, showStatus = false) => {
    return (
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Typography variant="h4" style={{ color: "#0275bb" }}>
          {key} Status
        </Typography>
        <Grid container spacing={2} style={{ marginTop: "20px" }}>
          {value.map((field) => {
            return (
              <Grid item xs={fieldSize}>
                <Box
                  style={{
                    textAlign: "center",
                    width: "100%",
                    height: "100%",
                    color: "#fff",
                    backgroundColor:
                      field.value === 0 || field.FieldStatus === "Open"
                        ? "#0b9444"
                        : "#ff0000",
                  }}
                >
                  <Typography
                    variant="h4"
                    style={{
                      paddingBlock: "7px",
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    {field.FieldName || field.court_name}
                  </Typography>
                  {showStatus && (
                    <Typography
                      variant="h6"
                      style={{
                        backgroundColor:
                          field.value === 0 || field.FieldStatus === "Open"
                            ? "#b8f0d2"
                            : "#fec6c6",
                        borderRadius: "4px",
                        color:
                          field.value === 0 || field.FieldStatus === "Open"
                            ? "#0b9444"
                            : "#ff0000",
                        fontSize: "12px",
                        fontWeight: 500,
                        margin: "10px",
                        padding: "7px 5px 7px 5px",
                        textTransform: "uppercase",
                        textAlign: "center",
                      }}
                    >
                      {field.FieldStatus !== undefined
                        ? field.FieldStatus
                        : field.value === 0
                        ? "UNOCCUPIED"
                        : "OCCUPIED"}
                    </Typography>
                  )}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        style={{
          borderBottom: "3px solid black",
          padding: "20px 5px",
          margin: "0px 20px",
        }}
      >
        {fieldsData &&
          Object.entries(fieldsData).map(([key, value]) =>
            renderFields(key, value, 3, true)
          )}
      </Grid>
      <Grid container style={{ margin: "0px 20px" }}>
        {courtsData &&
          Object.entries(courtsData).map(([key, value], index, arr) => (
            <Grid
              item
              xs={6}
              style={{
                borderRight:
                  index < arr.length - 1 ? "3px solid black" : "none",
              }}
            >
              {renderFields(key, value, 12, true)}
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

export default McpStatus;
